import { define } from '../redux-request';
import api from '../../api/api';

export const GET_REFILLS = define('GET_REFILLS');

export function getRefillsRequest(data) {
  return GET_REFILLS.request(() => api.getRefills(data));
}

export const CHANGE_REFILE = define('CHANGE_REFILE');

export function changeRefileData(data) {
  return {
    type: CHANGE_REFILE,
    payload: data,
  };
}
